import { datadogLogs } from '@datadog/browser-logs';

type LogLevel = 'error' | 'warn' | 'info' | 'debug';

interface LogParams {
  message: string;
  error?: Error | unknown;
  context?: Record<string, any>;
}

export const logger = {
  log: (
    { message, error, context = {} }: LogParams,
    level: LogLevel = 'info',
  ) => {
    // Only log to datadog in non-local environments
    if (process.env.REACT_APP_ENV !== 'local') {
      datadogLogs.logger.log(
        message,
        {
          error: error instanceof Error ? error.message : error,
          ...context,
        },
        level,
      );
    }

    // log to console in development
    if (process.env.NODE_ENV === 'development') {
      console[level](message, { error, ...context });
    }
  },

  error: (params: LogParams) => logger.log(params, 'error'),
  warn: (params: LogParams) => logger.log(params, 'warn'),
  info: (params: LogParams) => logger.log(params, 'info'),
  debug: (params: LogParams) => logger.log(params, 'debug'),
};

export const logEvent = (
  message: string,
  context: Record<string, any> = {},
) => {
  datadogLogs.logger.log(message, context);
};
